// extracted by mini-css-extract-plugin
module.exports = {"submitSection":"submit-section_submitSection__2l7qn","totalPrice":"submit-section_totalPrice__2PfUJ"};